import { c as _c } from "react/compiler-runtime";
import Close from "@mui/icons-material/Close";
import { alpha, Box, Divider, Drawer, IconButton, Stack, Typography, useTheme } from "@mui/material";
import React, { useCallback, useEffect, useRef } from "react";
import { useI18nContext, usePlaygroundSlugs } from "#/shared/hooks";
import { ProjectBrowserContent } from "./ProjectBrowserContent";
import { useProjectBrowserContext } from "./ProjectBrowserContext";
type ProjectBrowserProps = {
  onSelectProject?: (projectSlug: string) => void;
};
export const ProjectBrowser: React.FC<ProjectBrowserProps> = t0 => {
  const $ = _c(42);
  const {
    onSelectProject
  } = t0;
  const {
    LL
  } = useI18nContext();
  const theme = useTheme();
  const {
    isOpen,
    closeBrowser
  } = useProjectBrowserContext();
  const {
    setProject
  } = usePlaygroundSlugs();
  let t1;
  if ($[0] !== closeBrowser || $[1] !== onSelectProject || $[2] !== setProject) {
    t1 = slug => {
      closeBrowser();
      setProject(slug);
      onSelectProject?.(slug);
    };
    $[0] = closeBrowser;
    $[1] = onSelectProject;
    $[2] = setProject;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSelectProject = t1;
  let t2;
  if ($[4] !== closeBrowser) {
    t2 = () => {
      closeBrowser();
    };
    $[4] = closeBrowser;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleClose = t2;
  const searchInputRef = useRef(null);
  let t3;
  let t4;
  if ($[6] !== handleClose || $[7] !== isOpen) {
    t3 = () => {
      if (!isOpen) {
        return;
      }
      const handleKeyDown = ev => {
        if (ev.key === "Escape") {
          ev.preventDefault();
          handleClose();
          return;
        }
        if ((ev.ctrlKey || ev.metaKey) && ev.key === "f") {
          ev.preventDefault();
          searchInputRef.current?.focus();
          return;
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    };
    t4 = [isOpen, handleClose];
    $[6] = handleClose;
    $[7] = isOpen;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      xs: "100%",
      md: "800px"
    };
    t6 = {
      xs: "100vw",
      md: "90vw"
    };
    t7 = {
      md: 300
    };
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[13] !== theme.palette.background.paper) {
    t8 = alpha(theme.palette.background.paper, 0.68);
    $[13] = theme.palette.background.paper;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = {
      paper: {
        sx: {
          width: t5,
          maxWidth: t6,
          minWidth: t7,
          background: t8,
          backdropFilter: "blur(18px)"
        }
      }
    };
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      keepMounted: false
    };
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      height: "100%",
      display: "flex",
      flexDirection: "column"
    };
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      p: 2,
      pb: 1.5,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    };
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      fontWeight: 600
    };
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== LL) {
    t14 = LL.PROJECT_BROWSER();
    $[21] = LL;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14) {
    t15 = <Typography variant="h6" component="h2" sx={t13}>{t14}</Typography>;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Close />;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== handleClose) {
    t17 = <IconButton onClick={handleClose} size="small" aria-label="Close project browser">{t16}</IconButton>;
    $[26] = handleClose;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t15 || $[29] !== t17) {
    t18 = <Box sx={t12}>{t15}{t17}</Box>;
    $[28] = t15;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Divider />;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== handleSelectProject) {
    t20 = <ProjectBrowserContent onSelectProject={handleSelectProject} searchInputRef={searchInputRef} />;
    $[32] = handleSelectProject;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t18 || $[35] !== t20) {
    t21 = <Stack sx={t11}>{t18}{t19}{t20}</Stack>;
    $[34] = t18;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== handleClose || $[38] !== isOpen || $[39] !== t21 || $[40] !== t9) {
    t22 = <Drawer anchor="left" open={isOpen} onClose={handleClose} aria-label="Project browser" slotProps={t9} ModalProps={t10}>{t21}</Drawer>;
    $[37] = handleClose;
    $[38] = isOpen;
    $[39] = t21;
    $[40] = t9;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  return t22;
};